import { createSlice } from '@reduxjs/toolkit'

export interface ICommonState {
    isSiderOpen: boolean
}

const initialState: ICommonState = {
    isSiderOpen: false
}

const commonSlice = createSlice({
    name: 'ui/common',
    initialState,
    reducers: {
        toggleSider(state) {
            state.isSiderOpen = !state.isSiderOpen
        }
    }
})

export const commonActions = commonSlice.actions
export default commonSlice.reducer
